import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios';
import {
  CreateItem,
  CreateItemRequest,
  CreateItemResponse,
  CreatePsgDetailsRequest,
  t_paymant_due_date,
  BillingProcessResponse,
  t_billing_process,
  FilterHospitalResponse,
  ItemLinkInspecResponse,
  ItemLinkInspecRequest,
} from '../types';
import { HospitalRequest } from '../types/hospitalVisitRecord';

class BillingProcess {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }
  billingProcessItem(param: { pageNumber: number; searchValue?: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `globalsearch`,
      data: {
        query: param.searchValue,
        app_id: 'CPAP',
        datastore_id: 't_cpap_instructions',
        category: 'items',
        return_item_list: true,
        item_search_params: {
          sort_fields: [{ id: 'created_at', order: 'desc' }],
          per_page: 20,
          page: param.pageNumber,
        },
      },
    };
    return this.axios(request);
  }
  getAllCPAPByMedical(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_cpap_instructions/items/search`,
      data: {
        conditions: [
          {
            id: 'facility_name',
            search_value: [data],
            exact_match: true,
            include_null: false,
          },
          {
            id: 'suspension_flg',
            search_value: ['1'],
            not_match: true,
            include_null: false,
          },
        ],
        page: 1,
        per_page: 0,
        use_display_id: true,
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ],
      },
    };
    return this.axios(request);
  }
  getCPAPByPatientNames(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_cpap_instructions/items/search`,
      data: {
        conditions: [
          {
            id: 'patient_name',
            search_value: data,
            exact_match: true,
            include_null: false,
          },
          {
            id: 'suspension_flg',
            search_value: ['1'],
            not_match: true,
            include_null: false,
          },
        ],
        page: 1,
        per_page: 0,
        use_display_id: true,
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ],
      },
    };
    return this.axios(request);
  }
  getProcessItemPayment(params: { item: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_paymant_due_date/items/search`,
      data: {
        per_page: 20,
        page: 1,
        use_display_id: true,
        conditions: [
          {
            search_value: [params],
            id: 'invoice_month',
            exact_match: true,
          },
        ],
      },
    };
    return this.axios(request);
  }

  createItem(data: CreateItem): AxiosPromise<CreateItemResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_paymant_due_date/items/new`,
      data: {
        item: data.items,
        return_item_result: true,
      },
    };
    return this.axios(request);
  }

  updateItemCreate(data: t_paymant_due_date): AxiosPromise<CreateItemRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_paymant_due_date/items/edit/${data.i_id}`,
      data: { item: data, use_display_id: true, is_force_update: true, return_item_result: true },
    };
    return this.axios(request);
  }
  updatePsgDetailsCreate(data: any): AxiosPromise<CreatePsgDetailsRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/edit/${data.invoice_id}`,
      data: {
        item: {},
        return_item_result: true,
        is_sync_related_items: true,
        related_ds_items: {
          t_psg_details: data.related_ds_items,
        },
        use_display_id: true,
        is_force_update: true,
      },
    };
    return this.axios(request);
  }

  getBillForFacility(params: { invoice_month: string | string[]; facility_id: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/search`,
      data: {
        per_page: 20,
        page: 1,
        use_display_id: true,
        conditions: [
          {
            search_value: Array.isArray(params.invoice_month) ? params.invoice_month : [params.invoice_month],
            include_null: false,
            id: 'invoice_month',
            exact_match: true,
          },
          {
            search_value: [params.facility_id],
            include_null: false,
            id: 'facility_id',
            exact_match: true,
          },
        ],
      },
    };
    return this.axios(request);
  }

  searchBills(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/search`,
      data: {
        per_page: 'per_page' in params ? params.per_page : 20,
        page: params.page,
        use_display_id: true,
        conditions: params.conditions,
        sort_field_id: params.sort_field_id,
        sort_order: params.sort_order,
        sort_fields: params.sort_fields,
        include_links: true,
      },
    };
    if (!('include_lookups' in params)) {
      request.data.include_lookups = true;
    }
    return this.axios(request);
  }

  searchBillRegister(param: { facility_id: string; invoice_month: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/search`,
      data: {
        per_page: 0,
        page: 1,
        use_display_id: true,
        include_lookups: true,
        conditions: [
          {
            search_value: [param.facility_id],
            include_null: false,
            id: 'facility_id',
            exact_match: true,
          },
          {
            search_value: [param.invoice_month],
            include_null: false,
            id: 'invoice_month',
            exact_match: true,
          },
        ],
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ],
      },
    };
    return this.axios(request);
  }

  registerNewBill(data: {
    facility_id: string;
    invoice_month: string;
    facility_name: string;
    editing_status_by_clinic?: string;
  }): AxiosPromise<BillingProcessResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/new`,
      data: {
        item: data,
        return_item_result: true,
      },
    };
    return this.axios(request);
  }

  searchHospitalVisit(params: {
    facility_id: string;
    invoice_month: string;
    page: number;
    per_page: number;
    facilityId: string;
    conditions?: any[];
  }): AxiosPromise<HospitalRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        include_lookups: true,
        conditions: [
          {
            search_value: [params.invoice_month],
            include_null: false,
            id: 'target_month',
            exact_match: true,
          },
          {
            search_value: [params.facility_id],
            include_null: false,
            id: 'facility_id',
            exact_match: true,
          },
          ...(params.conditions ?? []),
        ],
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ],
      },
    };
    return this.axios(request);
  }

  searchBillDetailNearest(params: {
    facility_id: string;
    page: number;
    per_page: number;
  }): AxiosPromise<BillingProcessResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        conditions: [
          {
            search_value: [params.facility_id],
            include_null: false,
            id: 'facility_id',
            exact_match: true,
          },
        ],
        sort_field_id: 'invoice_month',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }

  searchBillDetailCPAPSpecial(params: {
    facility_id: string;
    sp_price: string;
    invoice_month: string;
    page: number;
    per_page: number;
  }): AxiosPromise<HospitalRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        conditions: [
          {
            search_value: [params.invoice_month],
            include_null: false,
            id: 'invoice_month',
            exact_match: true,
          },
          {
            search_value: [params.facility_id],
            include_null: false,
            id: 'facility_id',
            exact_match: true,
          },
          {
            search_value: [params.sp_price],
            include_null: false,
            id: 'sp_price',
            exact_match: true,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }

  searchBillDetailCPAP(params: {
    facility_id: string;
    sp_price: string;
    invoice_month: string;
    page: number;
    per_page: number;
  }): AxiosPromise<HospitalRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        conditions: [
          {
            search_value: [params.invoice_month],
            id: 'invoice_month',
            exact_match: true,
            included_null: false,
          },
          {
            search_value: [params.facility_id],
            id: 'facility_id',
            exact_match: true,
            include_null: false,
          },
          {
            search_value: [params.sp_price],
            id: 'sp_price',
            exact_match: true,
            not_match: true,
            include_null: false,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }

  searchBillDetailPSG(params: {
    facility_id: string;
    invoice_month: string;
    page: number;
    per_page: number;
    sort_fields?: any;
  }): AxiosPromise<HospitalRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_psg_details/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        conditions: [
          {
            search_value: [params.invoice_month],
            id: 'invoice_month',
            exact_match: true,
            included_null: true,
          },
          {
            search_value: [params.facility_id],
            id: 'facility_id',
            exact_match: true,
            include_null: true,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
        sort_fields: params.sort_fields ?? [],
      },
    };
    return this.axios(request);
  }

  searchBillDetailSimple(params: {
    facility_id: string;
    invoice_month: string;
    page: number;
    per_page: number;
  }): AxiosPromise<HospitalRequest> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_simple_inspection_details/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        conditions: [
          {
            search_value: [params.invoice_month],
            id: 'invoice_month',
            exact_match: true,
            included_null: true,
          },
          {
            search_value: [params.facility_id],
            id: 'facility_id',
            exact_match: true,
            include_null: true,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }

  importItems(param: any, importCount: number, isUpdate?: boolean): AxiosPromise<any> {
    const formData = new FormData();
    formData.append('file', param, 'test.csv');
    formData.append('filename', 'test.csv');
    formData.append('replace_all', 'false');
    if (isUpdate) {
      formData.append('append', 'false');
      formData.append('key_field_displayid', 'csv_key');
    } else {
      formData.append('append', 'true');
    }
    formData.append('no_queue', (importCount <= 100).toString());

    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/import`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    };
    return this.axios(request);
  }
  updateHospital(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/edit/${params.i_id}`,
      data: {
        item: params,
        use_display_id: true,
        return_item_result: true,
        is_force_update: true,
      },
    };
    return this.axios(request);
  }

  updateSimple(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/edit/${data.invoice_id}`,
      data: {
        item_id: data.invoice_id,
        item: {},
        return_item_result: true,
        is_sync_related_items: true,
        related_ds_items: {
          t_simple_inspection_details: data.data_related,
        },
        is_force_update: true,
      },
    };
    return this.axios(request);
  }
  getHospitalForCPAP(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        per_page: params.page * 12,
        page: 1,
        use_display_id: true,
        include_lookups: true,
        conditions: [
          {
            search_value: [params.cpap_id],
            include_null: false,
            id: 'cpap_id',
            exact_match: true,
          },
        ],
        sort_field_id: 'target_month_num',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }
  getPaymenDueDateFromInvoiceMonth(params: {
    invoice_month: string;
    page: number;
    per_page: number;
  }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_paymant_due_date/items/search`,
      data: {
        per_page: 1,
        page: params.page,
        use_display_id: true,
        conditions: [
          {
            search_value: [params.invoice_month],
            id: 'invoice_month',
            include_null: false,
            exact_match: true,
          },
        ],
      },
    };
    return this.axios(request);
  }

  importCSV(params: { filename: string; file: any; importCount: number; appendFalse?: boolean }): AxiosPromise<any> {
    const formData = new FormData();
    formData.append('file', params.file, params.filename);
    formData.append('filename', params.filename);
    formData.append('replace_all', 'false');
    formData.append('append', params.appendFalse ? 'false' : 'true');
    formData.append('key_field_displayid', 'csv_key');
    formData.append('no_queue', (params.importCount <= 100).toString());
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/import`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    };
    return this.axios(request);
  }

  searchInvoice(params: { per_page: number; page: number; conditions: any[] }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        use_display_id: true,
        conditions: params.conditions,
      },
    };
    return this.axios(request);
  }
  getBillingCandidate(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      url: `applications/CPAP/reports/billing_candidate/filter`,
      method: 'POST',
      data: {
        conditions: params.conditions,
        sort_fields: [
          { id: 'patient_name', order: 'asc' },
          { id: 'target_month_num', order: 'desc' },
        ],
        include_item_ref: true,
        per_page: 0,
        page: 1,
      },
    };
    return this.axios(request);
  }
  bulkAction(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      url: `applications/CPAP/datastores/t_hospital_visit/items/bulkaction/${params.action}`,
      method: 'POST',
      data: {
        conditions: params.conditions,
        item: params.item,
        comment: params.comment,
        max_items: params.max_items,
        use_display_id: true,
        continue_proc: true,
      },
    };
    return this.axios(request);
  }
  searchHospital(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        per_page: params.per_page,
        page: params.page,
        conditions: params.conditions,
        sort_fields: params.sort_fields ?? [],
        use_display_id: true,
      },
    };
    if (!('include_lookups' in params)) {
      request.data.include_lookups = true;
    }
    return this.axios(request);
  }
  searchReportHospital(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/reports/hospital_visit_and_links/filter`,
      data: {
        per_page: params.per_page,
        page: params.page,
        conditions: params.conditions,
        include_item_ref: true,
      },
    };
    return this.axios(request);
  }
  createHospital(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/new`,
      data: {
        item: params,
        return_item_result: true,
      },
    };
    return this.axios(request);
  }
  deleteHospital(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'DELETE',
      url: `applications/CPAP/datastores/t_hospital_visit/items/delete/${param.i_id}`,
      data: {
        item: {},
        delete_linked_items: true,
      },
    };
    return this.axios(request);
  }

  deletePSG(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'DELETE',
      url: `applications/CPAP/datastores/t_psg_details/items/delete/${param.i_id}`,
      data: {
        item: {},
        delete_linked_items: true,
      },
    };
    return this.axios(request);
  }

  deleteInSpection(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'DELETE',
      url: `applications/CPAP/datastores/t_simple_inspection_details/items/delete/${param.i_id}`,
      data: {
        item: {},
        delete_linked_items: true,
      },
    };
    return this.axios(request);
  }

  changeStatusBillInvoice(params: any): AxiosPromise<t_billing_process> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/action/${params.i_id}/a_Invoicing_completed`,
      data: {
        item: params.values,
        return_item_result: true,
        is_force_update: true,
      },
    };
    return this.axios(request);
  }

  updateBillInvoice(params: any): AxiosPromise<t_billing_process> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/edit/${params.i_id}`,
      data: {
        item: params.values,
        return_item_result: true,
        is_force_update: true,
      },
    };
    return this.axios(request);
  }

  updateLastBillInvoice(params: any): AxiosPromise<t_billing_process> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/action/${params.i_id}/a_invoice_closed`,
      data: {
        item: {},
        return_item_result: true,
        is_force_update: true,
        use_display_id: true,
      },
    };
    return this.axios(request);
  }
  executeAction(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/action/${param.i_id}/${param.action}`,
      data: {
        item: param.item,
        return_item_result: true,
        is_force_update: true,
        use_display_id: true,
      },
    };
    return this.axios(request);
  }
  getBillDetail(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/t_invoice/items/details/${param.i_id}?format=map`,
    };
    return this.axios(request);
  }

  getBillProcessDetail(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/t_invoice/items/details/${param.i_id}`,
    };
    return this.axios(request);
  }

  getMedicalDetail(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/t_medical_institution/items/details/${param.item_id}?format=map`,
    };
    return this.axios(request);
  }

  searchCPAPFromHospital(param: {
    invoice_id: string;
    billing_type: string[];
    page: number;
    per_page: number;
  }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        conditions: [
          {
            search_value: param.billing_type,
            id: 'billing_type',
            exact_match: true,
            included_null: false,
          },
          {
            search_value: [param.invoice_id],
            id: 'invoice_id',
            exact_match: true,
            included_null: false,
          },
        ],
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          {
            id: 'cpap_id',
            order: 'asc',
          },
          { id: 'target_month_num', order: 'desc' },
        ],
        page: param.page,
        per_page: param.per_page,
        use_display_id: true,
      },
    };
    return this.axios(request);
  }

  searchCPAPFromHospitalInMonth(param: {
    invoice_id: string;
    billing_type: string;
    page: number;
    per_page: number;
  }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_hospital_visit/items/search`,
      data: {
        conditions: [
          {
            search_value: ['o_recovery', 'o_advance_payment'],
            id: 'billing_type',
            exact_match: true,
            included_null: false,
          },
          {
            search_value: [param.invoice_id],
            id: 'invoice_id',
            exact_match: true,
            included_null: false,
          },
        ],
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ],
        page: param.page,
        per_page: param.per_page,
        use_display_id: true,
      },
    };
    return this.axios(request);
  }

  updateInvoice(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/edit/${data.i_id}`,
      data: {
        item: data,
        related_ds_items: 'related_ds_items' in data ? data.related_ds_items : undefined,
        return_item_result: true,
        is_force_update: true,
      },
    };
    return this.axios(request);
  }

  SearchTSimpleInspection(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/t_invoice/items/links/${data.i_id}?use_display_id=true&include_lookups=true`,
    };
    return this.axios(request);
  }

  SearchPSG(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/t_invoice/items/links/${data.i_id}?use_display_id=true&include_lookups=true`,
    };
    return this.axios(request);
  }
  getImportResult(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `tasks?stream_id=${param.stream_id}&all=true`,
    };
    return this.axios(request);
  }
  getLinkItems(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/${param.dataStore}/items/links/${param.i_id}?use_display_id=true&include_lookups=true`,
    };
    return this.axios(request);
  }
  getCountInvoice(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/search`,
      data: {
        per_page: 0,
        page: 1,
        use_display_id: true,
        include_lookups: true,
        conditions: param.conditions,
        return_count_only: true,
        sort_fields: [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ],
      },
    };
    return this.axios(request);
  }
  getListOtherDetail(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_other_details/items/search`,
      data: {
        per_page: 0,
        page: 1,
        use_display_id: true,
        conditions: param.conditions,
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }
  getInvoiceOtherDetail(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/reports/invoice_detail_other/filter`,
      data: {
        per_page: 0,
        page: 1,
        include_item_ref: true,
        conditions: [
          {
            search_value: [param?.invoice_id],
            id: 'invoice_id',
            exact_match: true,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }
  updateOtherDetail(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/edit/${data.invoice_id}`,
      data: {
        item: {},
        return_item_result: true,
        is_sync_related_items: true,
        related_ds_items: {
          t_other_details: data.related_ds_items,
        },
        use_display_id: true,
        is_force_update: true,
      },
    };
    return this.axios(request);
  }
  filterHospitalVisitandLinks(params: {
    per_page: number;
    page: number;
    facility_id: string;
    invoice_month: string;
    return_id_value_results?: boolean;
    include_item_ref?: boolean;
    conditions?:
      | Array<{
          conditions: Array<{
            search_value: Array<string>;
            id: string;
          }>;
          use_or_condition?: boolean;
        }>
      | Array<{
          search_value: Array<string>;
          id: string;
        }>;
    sort_fields?: Array<{
      id: string;
      order: string;
    }>;
  }): AxiosPromise<FilterHospitalResponse> {
    const request: AxiosRequestConfig = {
      url: 'applications/CPAP/reports/hospital_visit_and_links/filter',
      method: 'POST',
      data: {
        per_page: params.per_page,
        page: params.page,
        return_id_value_results: params.return_id_value_results,
        include_item_ref: params.include_item_ref,
        conditions: [
          {
            search_value: [params.invoice_month],
            id: 'target_month',
          },
          {
            search_value: [params.facility_id],
            id: 'facility_id',
          },
          ...(params.conditions ?? []),
        ],
        sort_fields: params.sort_fields,
      },
    };
    return this.axios(request);
  }
  getItemLinkInspec(param: ItemLinkInspecRequest): AxiosPromise<ItemLinkInspecResponse> {
    const request: AxiosRequestConfig = {
      url: 'applications/CPAP/reports/invoice_detail_simple/filter',
      method: 'POST',
      data: {
        per_page: 0,
        page: 1,
        include_item_ref: true,
        conditions: [
          {
            search_value: [param.invoice_id],
            id: 'invoice_id',
            exact_match: true,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }
  getInvoiceDetailPSG(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/reports/invoice_detail_psg/filter`,
      data: {
        per_page: 0,
        page: 1,
        include_item_ref: true,
        conditions: [
          {
            search_value: [param.invoice_id],
            id: 'invoice_id',
            exact_match: true,
          },
        ],
        sort_field_id: 'created_at',
        sort_order: 'desc',
      },
    };
    return this.axios(request);
  }
  makeTrueConsultationStatus(params: {
    facility_id: string;
    invoice_month: string;
  }): AxiosPromise<{ has_error: boolean; result: any }> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: 'applications/CPAP/datastores/t_hospital_visit/items/bulkaction/UpdateItem',
      data: {
        conditions: [
          {
            id: 'facility_id',
            search_value: [params.facility_id],
          },
          {
            id: 'target_month',
            search_value: [params.invoice_month],
          },
          {
            id: 'hospital_visit',
            not_match: true,
            search_value: ['o_yes', 'o_no'],
          },
        ],
        item: {
          hospital_visit: 'o_yes',
          billing_type: 'o_normal',
          invoice_month: params.invoice_month,
        },
        use_display_id: true,
        is_force_update: true,
        comment: '一括受診登録',
        max_items: 300,
        continue_proc: true,
      },
    };
    return this.axios(request);
  }

  getStatusBill(): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/m_app_options/items/search`,
      data: {
        conditions: [
          {
            id: 'key',
            search_value: ['latest_invoice_month'],
          },
        ],
        per_page: 0,
        page: 1,
        use_display_id: true,
        sort_field_id: 'created_at',
        sort_order: 'asc',
      },
    };
    return this.axios(request);
  }
  updateStatusBill(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/m_app_options/items/edit/${params.i_id}`,
      data: {
        comment: `${params.curYear}年${params.monthCur}月度請求書確定`,
        item: {
          value: `${params.curYear}${params.monthCur}`,
        },
        use_display_id: true,
        is_force_update: true,
        return_item_result: true,
      },
    };
    return this.axios(request);
  }
  updateFile(params: any): AxiosPromise<any> {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('filename', params.filename);
    formData.append('datastore_id', '606e964ac489ba0001ebab20');
    formData.append('application_id', '60585622375efa000189be58');
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `items/${params.i_id}/fields/63e7b84f76c1796c98c60c12/attachments`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    };
    return this.axios(request);
  }
  updateItemInvoice(params: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_invoice/items/edit/${params.i_id}`,
      data: params.data,
    };
    return this.axios(request);
  }
}

export default BillingProcess;
